import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import rightArrow from '../../images/right-arrow.svg';
import theme from '../../styles/theme';
import LazyImage from '../LazyLoadImage';

const btGreen = theme.colors.green;
const btPurple = theme.colors.purple;
const btOrange = theme.colors.orange;

const ButtonGradient = styled.button`
  background: ${(props) => mapColors(props) || btGreen};
  font-family: 'Lato', sans-serif;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  border: none;
  border-radius: 32px;
  color: white;
  font-size: ${(props) => props.fontSize || '16px'};
  max-width: 320px;
  padding: 15px 30px;
  transition: all 0.4s;
  min-width: 220px;

  img {
    margin-left: 12px;
  }

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: 0;
  }
`;

const mapColors = ({ color }) =>
  ({
    green: btGreen,
    purple: btPurple,
    orange: btOrange,
  }[color]);

const Button = ({ children, color, shadow = true, fontSize, onClick, withArrow }) => (
  <ButtonGradient onClick={onClick} color={color} shadow={shadow} fontSize={fontSize}>
    {children}
    {withArrow ? <img src={rightArrow} alt="right arrow" /> : null}
  </ButtonGradient>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  shadow: PropTypes.bool,
  withArrow: PropTypes.bool,
};

export default Button;
